
















































import { defineComponent, computed } from '@nuxtjs/composition-api';
import { appStore } from '@/store';

export default defineComponent({
  components: {},
  setup() {
    const items = [
      {
        isEnabled: true,
        imageFileName: 'matching.jpg',
        imagePoint: null,
        title: 'ビジネスマッチング',
        titleEn: 'Matching',
        subTitle: 'マッチングのご依頼は24時間いつでも可能！',
        subText: appStore.settingContents.global_top_business_matching_sub_text,
        subTitle2: appStore.appConfig.bank.ba_name + 'のマッチング担当者が面談を調整',
        subText2: 'ご依頼いただいた商談については' + appStore.appConfig.bank.ba_name + 'のマッチング担当者が責任をもって面談設定まで調整をします。他の金融機関のBig Advance事務局とも連携し、地域を超えたマッチングを実現しています。',
        caption: null
      },
      {
        isEnabled: true,
        imageFileName: 'fukuri.png',
        imagePoint: null,
        title: '福利厚生サービス',
        titleEn: 'FUKURI',
        subTitle: '従業員への福利厚生サービスをご提供',
        subText: '無制限に従業員アカウントを発行でき、従業員のみなさまは全国のBig Advance参加企業がクーポンを提供する福利厚生サービス「FUKURI」をご利用いただけます。 Advanceなら管理画面から指定の項目に入力するだけで手軽に会社ホームページをオープンできます。追加費用はもちろんかかりません。',
        subTitle2: 'FUKURIにクーポンを掲載して集客',
        subText2: '他のBigAdvance利用企業の従業員向けに「FUKURI」サービス内にクーポンを掲載し、今すぐ集客を開始できます。',
        caption: null
      },
      {
        isEnabled: true,
        imageFileName: 'hp.png',
        imagePoint: null,
        title: '会社ホームページ',
        titleEn: 'Homepage',
        subTitle: '15分で会社ホームページを作成',
        subText: '会社の情報収集はインターネットが主流になっています。ホームページをしっかり準備し、会社の強みや特徴などをアピールしていくことが重要です。Big Advanceなら管理画面から指定の項目に入力するだけで手軽に会社ホームページをオープンできます。追加費用はもちろんかかりません。',
        subTitle2: 'スマホ対応、SEO対応もおまかせ',
        subText2: 'スマホやタブレットでの表示への最適化やSEO対策（Google等での検索ランキング対策）、セキュリティ対策も実施していますので、個別にサービスを申し込む必要はありません。すべてBig Advanceの基本機能に含まれています。',
        caption: null
      },
      {
        isEnabled: true,
        imageFileName: 'innovation.jpg',
        imagePoint: {
          class: 'innovation-point point',
          imageFileName: 'fukidashi_3.png'
        },
        title: 'オープンイノベーション',
        titleEn: 'Open Innovation',
        subTitle: '大手有名企業とのイノベーション企画に参加',
        subText: 'Big Advanceのコンセプトにご賛同いただいた数百社の大手企業様がパートナー企業として参加。自由に企画に応募し、大手有名企業様とつながることができます。',
        subTitle2: appStore.appConfig.bank.ba_name + 'の運営事務局が面談を調整',
        subText2: 'ご応募いただいた際のパートナー企業様との面談設定は金融機関が実施するのでより高い確率で提案の機会におつなぎすることができます。みなさんのアイディアとパートナー企業のリソースを組み合わせることで、これまでにない新たなサービスを創出してください。',
        caption: null
      },
      {
        isEnabled: true,
        imageFileName: 'chat.jpg',
        imagePoint: {
          class: 'chat-point point',
          imageFileName: 'fukidashi_4.png'
        },
        title: 'チャット',
        titleEn: 'Chat',
        subTitle: 'メールより気軽に、電話より便利に',
        subText: 'Big Advanceはお客様と金融機関をつなぐコミュニケーションプラットフォームでもあります。普段使い慣れているメッセージングサービスのような感覚で金融機関の担当者とコミュニケーションができるようになります。',
        subTitle2: '金融機関をもっと身近に',
        subText2: appStore.settingContents.global_top_chat_sub_text,
        caption: null
      },
      {
        isEnabled: appStore.settingContents.global_top_show_feature_payment,
        imageFileName: 'ba-payment.png',
        title: 'ちゃんと請求書',
        titleEn: 'Payment',
        subTitle: '請求書や納品書を簡単な操作＆ツール1つで完結',
        subText: 'ボタンや項目欄をクリックして順番に入力をしていくだけでとっても簡単。見積書データを選択して請求書や納品書に引用作成できるので入力ミス防止につながります。無駄な操作がいらないシンプルさはパソコンやスマホが不慣れな方におすすめ。',
        subTitle2: 'シンプルな画面で知りたい情報がすぐ見つかる',
        subText2: 'データで管理することによりチェックや過去の案件を探す手間を減らし、請求業務の効率化を図ります。オフィスにファイルや書類を置くスペースも不要。',
        caption: '※ちゃんと請求書のご利用には追加料金が発生します。'
      },
      {
        isEnabled: appStore.settingContents.global_top_show_feature_business_succession,
        imageFileName: 'business-succession.png',
        title: '事業承継',
        titleEn: 'Business succession',
        subTitle: '株価試算機能',
        subText: 'スムーズな事業承継の実現には、「自社株式の価値を計算すること」が不可欠です。Big Advanceでは、「親族内承継における相続税法上の株価」及び「第三者承継（M＆A等）における株価」を簡易的に試算することができます。',
        subTitle2: '相続税試算機能',
        subText2: '後継者の税負担を考慮した相続税対策や遺産分割を考えるためにも、大まかな相続税の額を把握しておくことが大切です。BigAdvanceでは、「相続税」を簡易的に試算することができます。',
        caption: '※株価・相続税の試算結果は限定された情報に基づく簡易的な試算となり、実際の相続・贈与・売買等にはご利用できません。'
      },
      {
        isEnabled: appStore.settingContents.global_top_show_feature_forum,
        imageFileName: 'forum.png',
        title: '経営相談掲示板',
        titleEn: 'Forum',
        subTitle: '経営に関する質問や悩みについて相談ができ、他会員より回答や助言が得られる',
        subText: ' 日々、会社を経営する中で発生するお悩みを、同じ立場の経営者と一緒にディスカッションできるサービスです。',
        subTitle2: '新規商品開発や福利厚生に関する相談など、投稿内容は様々',
        subText2: '自社のお悩みを相談することはもちろん、他の企業からの相談にも積極的に参加して一緒に課題を解決していきましょう。',
        caption: '※本掲示板はBig Advanceの開発元である(株)ココペリが管理しています'
      }
    ];

    const enabledItems = computed(() => {
      return items.filter(item => item.isEnabled);
    });
    return { enabledItems };
  }
});
